<template>
	<div class="default-input default-input--period" :class="{error : errors.length, disabled : disabled, 'default-input--bg' : inputGray}">
		<span class="default-input__label" v-if="label">{{ label }}</span>
		<div class="default-input__wrapper default-input__wrapper--2">
			<div class="default-input__wrapper-el">
				<span v-if="hashPrefix" class="default-input__span">с</span>
				<div class="default-input__input default-input__input--date">
					<v-date-picker class="date-calendar" color="green" :masks="{input: 'DD.MM.YYYY'}" :min-date="min" :max-date="max" v-model="value[0]">
						<template v-slot="{ inputValue, inputEvents }">
							<input
								ref="inputField1"
								:value="inputValue"
								v-on="inputEvents"
								:disabled="disabled"
								:inputmode="'numeric'"
								placeholder=""
							/>
						</template>
					</v-date-picker>
				</div>
			</div>
			<div class="default-input__wrapper-el">
				<span v-if="hashPrefix" class="default-input__span">до</span>
				<div class="default-input__input default-input__input--date">
					<v-date-picker class="date-calendar" color="green" :masks="{input: 'DD.MM.YYYY'}" :min-date="min" :max-date="max" v-model="value[1]">
						<template v-slot="{ inputValue, inputEvents }">
							<input
								ref="inputField2"
								:value="inputValue"
								v-on="inputEvents"
								:disabled="disabled"
								:inputmode="'numeric'"
								placeholder=""
							/>
						</template>
					</v-date-picker>
				</div>
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li v-for="(error,index) in errors" :key="index">{{ error.$message }}</li>
		</ul>
	</div>
</template>

<script>
import Inputmask from 'inputmask'


export default {
	name: "InputPeriod",
	emits: ["update:modelValue"],
	props: {
		modelValue: {
			type: Array,
			required: true,
			// validator(value) {
			// 	return value.length === 2
			// },
			default: () => {}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: ''
		},
		min: {
			type: [String, Number],
			default: null,
		},
		max: {
			type: [String, Number],
			default: null,
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
		hashPrefix: {
			type: Boolean,
			default: true,
		}
	},
	mounted() {
		Inputmask("99.99.9999", {
			placeholder: 'xx.xx.xxxx',
		}).mask(this.$refs.inputField1).mask(this.$refs.inputField2)
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		},
	},
}
</script>


